export default function Approach() {
  const steps = [
    {
      number: '01',
      title: 'Operational Audit',
      description: 'We analyze your current workflows, identify bottlenecks, and map opportunities for intelligent automation.'
    },
    {
      number: '02',
      title: 'System Architecture',
      description: 'Design structured AI systems aligned with your operational goals and compliance requirements.'
    },
    {
      number: '03',
      title: 'AI Implementation',
      description: 'Deploy automation workflows, integrate with existing tools, and ensure seamless operational adoption.'
    },
    {
      number: '04',
      title: 'Optimization & Reporting',
      description: 'Monitor performance, refine systems, and provide clear metrics on operational impact and ROI.'
    }
  ];

  return (
    <section id="approach" className="py-32 bg-[#FAFAFA] dark:bg-[#0a1520] transition-colors duration-300">
      <div className="max-w-[980px] mx-auto px-8">
        <h2 className="text-[64px] font-extralight text-center tracking-[-0.015em] text-[#0E1A2B] dark:text-[#e8edf4] mb-4">
          Strategy First. Systems Second.
        </h2>
        
        <p className="text-[21px] font-light text-center tracking-[-0.01em] text-[#5C6675] dark:text-[#8899aa] max-w-[720px] mx-auto mb-24">
          We begin with operational audits and strategic design before implementing automation. This ensures every AI system aligns with real workflows and business goals.
        </p>

        <div className="space-y-16">
          {steps.map((step, idx) => (
            <div
              key={idx}
              className="flex items-start gap-8 pb-16 border-b border-[#D9DEE5] dark:border-[#1e3247] last:border-b-0"
            >
              <div className="text-[72px] font-extralight tracking-[-0.02em] text-[#2F6BFF] dark:text-[#28D7C6] leading-none pt-2">
                {step.number}
              </div>
              <div className="flex-1 pt-3">
                <h3 className="text-[32px] font-light tracking-[-0.015em] text-[#0E1A2B] dark:text-[#e8edf4] mb-3">
                  {step.title}
                </h3>
                <p className="text-[19px] font-light leading-[1.5] tracking-[-0.01em] text-[#5C6675] dark:text-[#8899aa]">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}